<div class="auth-shell">
  <div class="auth-section content-section">
    <div class="logo">
      <img src="assets/kingsett-logo.svg" alt="logo" class="logo" />
    </div>
    <div class="auth-content">
      <router-outlet></router-outlet>
    </div>
  </div>
  <div class="auth-section banner-section">
    <div class="auth-banner" style="background-image: url('/assets/auth/background-image.png');">
    </div>
  </div>
</div>